import { Trash2, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { humanizeArea } from "pages/geoscape-data/clip/clip-ui/steps/step-1-define-boundary/boundary-item";

interface UploadedBoundarySummaryProps {
  // Unknown until the display copy has loaded.
  count?: number;
  area?: number;
  // Shown instead of the area when the shapes aren't loaded, e.g. "Loading preview…".
  status?: string;
  onRemove: () => void;
}

// An uploaded file is one unit: one row standing for all its shapes, with a single remove.
export const UploadedBoundarySummary = ({
  count,
  area,
  status,
  onRemove,
}: UploadedBoundarySummaryProps) => (
  <div className="h-16 flex flex-row items-center gap-4 px-3 rounded-lg border bg-muted/40">
    <Upload className="size-5 text-muted-foreground" />
    <div className="flex flex-col flex-1 min-w-0">
      <span className="text-sm font-medium">
        Uploaded boundary
        {count !== undefined &&
          `: ${count.toLocaleString()} shape${count === 1 ? "" : "s"}`}
      </span>
      <span className="text-xs text-muted-foreground">
        {area !== undefined ? `${humanizeArea(area)} · View only` : status}
      </span>
    </div>
    <Button
      variant="ghost"
      size="icon-sm"
      aria-label="Remove uploaded boundary"
      onClick={onRemove}
    >
      <Trash2 className="size-4" />
    </Button>
  </div>
);
